import type { Channel } from "@remi/types/channels";

import { hasCapability, type User } from "../base";
import { canViewChannel } from "./message";

export const channel = {
  read: (user: User, channel: Channel) => canViewChannel(user, channel),
  readOrganization: (user: User, organizationId: string | null) => {
    if (hasCapability(user, "conversation.read.all")) {
      return true;
    }
    if (hasCapability(user, "channel.readOrganization")) {
      return organizationId !== null && user.person.organizationId === organizationId;
    }
    if (hasCapability(user, "channel.read")) {
      return organizationId === null;
    }
    return false;
  },
};
